var _excluded = ["geometry", "shapeStyle"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { LineString, MultiLineString, MultiPolygon, Point } from 'ol/geom';
import Polygon from 'ol/geom/Polygon';
import formatLength from '../utils/formatLength';

var composeStyles = _ref => {
  var {
    areaStyle,
    geometryShape,
    lineStyle,
    showAreaMeasurements,
    showLineMeasurements,
    getArea
  } = _ref;
  var styles = [];
  var point = undefined;
  var areaLabel = '';
  var line = undefined;
  var isPolygon = geometryShape instanceof Polygon;
  var isLineString = geometryShape instanceof LineString;

  if (isPolygon) {
    point = geometryShape.getInteriorPoint();
    areaLabel = getArea(geometryShape);
    line = new LineString(geometryShape.getCoordinates()[0]);
  } else if (isLineString && showLineMeasurements) {
    point = new Point(geometryShape.getLastCoordinate());
    line = geometryShape;
  } // set segmentStyles styles for Polygon and LineString


  if (line && showLineMeasurements) {
    line.forEachSegment(function (a, b) {
      var segment = new LineString([a, b]);
      var lengthLabel = formatLength(segment);
      var segmentPoint = new Point(segment.getCoordinateAt(0.5)); // clone lineStyle to ensure that each shape is assigned a unique style object

      var clonedLineStyle = lineStyle.clone();
      clonedLineStyle === null || clonedLineStyle === void 0 ? void 0 : clonedLineStyle.setGeometry(segmentPoint);
      clonedLineStyle === null || clonedLineStyle === void 0 ? void 0 : clonedLineStyle.getText().setText(lengthLabel);
      styles.push(clonedLineStyle);
    });
  } // set area styles for Polygon


  if (areaLabel && showAreaMeasurements && isPolygon && point) {
    // clone areaStyle to ensure that each shape is assigned a unique style object
    var clonedAreaStyle = areaStyle.clone();
    clonedAreaStyle === null || clonedAreaStyle === void 0 ? void 0 : clonedAreaStyle.setGeometry(point);
    clonedAreaStyle === null || clonedAreaStyle === void 0 ? void 0 : clonedAreaStyle.getText().setText(areaLabel);
    styles.push(clonedAreaStyle);
  }

  return styles;
};
/**
 * Returns an array of styles for the `geometry`.
 *
 * If `geometry` is a MultiPolygon or MultiLineString the result contains
 * one "set of styles" for each Polygon or LineString in the multi geometry.
 * Otherwise it will contain a single "set of styles".
 *
 * A "set of styles" consists of a style for each line, followed by a style for the area.
 * For example, a MultiPolygon's result could contain
 * [linestyleA1, linestyleA2, linestyleA3, linestyleA4, areaStyleA, linestyleB1, linestyleB2, lineStyleB3, areaStyleB].
 *
 * The styles passed to this function (`areaStyle` and `lineStyle`) will be cloned
 * and used as templates for the resulting styles.
 */


var getMeasurementStyles = _ref2 => {
  var {
    geometry,
    shapeStyle
  } = _ref2,
      rest = _objectWithoutProperties(_ref2, _excluded);

  var isMultiPolygon = geometry instanceof MultiPolygon;
  var isMultiLineString = geometry instanceof MultiLineString;
  var isPolygon = geometry instanceof Polygon;
  var isLineString = geometry instanceof LineString;

  if (isPolygon || isLineString) {
    return [...shapeStyle, ...composeStyles(_objectSpread(_objectSpread({}, rest), {}, {
      geometryShape: geometry
    }))];
  }

  var geometryShapeList = [];

  if (isMultiPolygon) {
    geometryShapeList = geometry.getPolygons();
  }

  if (isMultiLineString) {
    geometryShapeList = geometry.getLineStrings();
  }

  var geometryStyleList = [...shapeStyle];
  geometryShapeList.forEach(shape => {
    var geometryStyle = composeStyles(_objectSpread(_objectSpread({}, rest), {}, {
      geometryShape: shape
    }));
    geometryStyleList.push(...geometryStyle);
  });
  return geometryStyleList;
};

export default getMeasurementStyles;